import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';


export const DetailDocument = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="billing">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Tutup Buku
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <div className="row">
              <div className="col-6">
                <ListHorizontal
                  title="Bulan"
                  content={formatDate(data?.monthly, 'MM/YYYY')}
                />
                <ListHorizontal
                  title="Note"
                  content={data?.note}
                />
                <ListHorizontal
                  title="Saldo"
                  content={currencyFormat(data?.saldo)}
                />
              </div>
              <div className="col-6">
                <ListHorizontal
                  title="Dibuat Oleh"
                  content={data?.created_by}
                />
                <ListHorizontal
                  title="Dibuat Tanggal"
                  content={formatDate(data?.created_at)}
                />
                {data.updated_by && (
                  <>
                    <ListHorizontal
                      title="Dipebaharui Oleh"
                      content={data?.updated_by}
                    />
                    <ListHorizontal
                      title="Dipebaharui Tanggal"
                      content={formatDate(data?.updated_at)}
                    />
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};
